import { useEffect, useCallback } from "react";
import { auth, rtdb } from "../config/firebase";
import { signOut } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";
import { onDisconnect, update, serverTimestamp, ref } from "firebase/database";

const offlineStatus = { isOnline: false, lastSeen: serverTimestamp() };

const useSignoutUser = () => {
  const [user, loading, error] = useAuthState(auth);
  const handleLogout = useCallback(async () => {
    if (user?.uid && rtdb) {
      const userStatusRef = ref(rtdb, `status/${user.uid}`);

      try {
        await onDisconnect(userStatusRef).cancel();
        await update(userStatusRef, offlineStatus);
      } catch (dbError) {
        console.error(
          "⚠️ RTDB UPDATE FAILED! This usually means permissions are gone or timing is off:",
          dbError.message,
          dbError
        );
      }
    } else {
    }
    signOut(auth)
      .then(() => {})
      .catch((error) => {})
      .finally(() => {});
  }, [user]);

  useEffect(() => {}, [user, loading, error]);
  return handleLogout;
};

export default useSignoutUser;

// import { useEffect, useCallback } from "react";
// import { auth, rtdb } from "../config/firebase";
// import { signOut } from "firebase/auth";
// import { useAuthState } from "react-firebase-hooks/auth";
// import { onDisconnect, update, serverTimestamp, ref } from "firebase/database";

// // ⚠️ Note: This definition is correct for Realtime Database's serverTimestamp
// const offlineStatus = { isOnline: false, lastSeen: serverTimestamp() };

// // The hook name should follow 'use' convention and not be async
// const useSignoutUser = () => {
//     // 1. Get the current user state
//     const [user, loading, error] = useAuthState(auth); // Added loading and error for better logging
//     // console.log("user",user)

//     // 2. Define the logout function
//     const handleLogout = useCallback(async () => {

//         // Ensure user and RTDB instance are available
//         if (user?.uid && rtdb) {

//             const userStatusRef = ref(rtdb, `status/${user.uid}`);

//             try {
//                 // Step 1: Cancel the automatic onDisconnect handler
//                 await onDisconnect(userStatusRef).cancel();

//                 // Step 2: Manually write the OFFLINE status (while token is valid)
//                 await update(userStatusRef, offlineStatus);

//             } catch (dbError) {
//                 // This catch block is critical for permission denied errors before signOut
//                 console.error(
//                     "⚠️ RTDB UPDATE FAILED! This usually means permissions are gone or timing is off:",
//                     dbError.message,
//                     dbError
//                 );
//             }
//         } else {

//         }

//         // Step 3: Revoke the token (Auth Sign Out)
//         signOut(auth)
//             .then(() => {

//             })
//             .catch((error) => {

//             })
//             .finally(() => {

//             });

//     }, [user]); // Dependency on 'user' is essential

//     // 3. Log initial state and render details (Optional but helpful for debugging)
//     useEffect(() => {

//     }, [user, loading, error]);

//     // Return the function so it can be used for a button click, etc.
//     return handleLogout;
// };

// export default useSignoutUser;
